<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      <b>Text Type Question</b>
    </div>
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>


    <div class="card-header nocollapse bg-info col-md-12 " *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="col-md-12 card-body">

      <form [formGroup]="questioninputTypeForm" #f="ngForm">


        <div class="row mb-3">
          <label data-required for="questioninputType" class="form-control-label col-md-2">Question Title<sup class="text-danger">&ast;</sup></label>
          <div class="col-md-10">
            <textarea rows="6" cols="13" maxlength="1000" id="questioninputType" name="questioninputType" formControlName="questioninputType" class="form-control" placeholder="Please Enter Question Title" #questioninputType></textarea>
          </div>
        </div>

        <div class="row mb-3">
          <label class="form-control-label col-md-2" for="questionCategoryId"> Category<sup class="text-danger">&ast;</sup></label>
          <div class="col-md-3">
            <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control custom-select-with-arrow">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                {{item.questionCategoryName}}
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <button type="button" class="btn btn-primary btn-action"
                    (click)="openCategoryModal()">
              <i class="fa fa-plus"></i> Create Category
            </button>
          </div>

          <label class="col-md-2 form-control-label" for="width"> Width</label>
          <div class="col-md-3">
            <input class="form-control" maxlength="1000" type="number" id="width" name="width" formControlName="width" placeholder="Width" />
          </div>
        </div>

        <div class="row mb-3">
          <label class="form-control-label col-md-2" for="shortName">Short Name</label>
          <div class="col-md-3">
            <input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" />
          </div>
          <div class="col-md-2"></div>
          <label class="col-md-2 form-control-label" for="maxCharacterLength" style="">Character Length</label>
          <div class="col-md-3">
            <input class="form-control mr-0" maxlength="1000" type="number" id="maxCharacterLength" name="maxCharacterLength" formControlName="maxCharacterLength" placeholder="Control Max Character Length" />
          </div>
        </div>


        <div class="col-md-12 d-flex justify-content-end">
          <button type="submit" class="btn btn-secondary btn-action me-2"
                  (click)="BackUrl()"
                  [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button type="button" class="btn btn-secondary btn-action me-2"
                  (click)="BackToSectionUrl()"
                  [hidden]="redirectedSectionId==null || redirectedSurveyId==null">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button type="submit"
                  [disabled]="!questioninputTypeForm.valid"
                  class="btn btn-primary btn-action"
                  (click)="saveQuestionInputType()">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      </form>
    </div>




  </div>
</div>

<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category<sup class="text-danger">&ast;</sup></label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
